import request from '../utils/request'

export function modifyDetail(detailId, qty) {
    return request({
        url: '/api/order/purchase/modify/detail',
        method: 'post',
        data: {
            detail_id: detailId,
            purchase_qty: qty
        }
    })
}

export function detailPurchase(puchaseId) {
    return request({
        url: '/api/order/purchase/details',
        method: 'get',
        params: {
            purchase_id: puchaseId
        }
    })
}

export function deletePurchase(purchaseId) {
    return request({
        url: '/api/order/purchase/delete',
        method: 'delete',
        params: {
            id: purchaseId
        }
    })
}

export function deleteDetail(detailId) {
    return request({
        url: '/api/order/purchase/delete/detail',
        method: 'delete',
        params: {
            detail_id: detailId
        }
    })
}
